// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__3y7yO","title":"BackImages_title__1tHxc","images":"BackImages_images__8tbcZ"};